import React, { ReactNode } from "react";
import styled from "styled-components";
import { EmptyStatesType } from "common/Icons/types";
import { useEmptyState } from "common/Icons/useEmptyState";

interface InlineEmptyProps {
  iconKey: EmptyStatesType;
  title: ReactNode;
  action?: ReactNode;
}

/**
 * A compact empty state with a line illustration, sized for a card. Kept for
 * the payout methods list (features/payouts); affiliation panels use
 * common/Empty/PanelEmpty.
 */
export const InlineEmpty = ({ iconKey, title, action }: InlineEmptyProps) => {
  const EmptyStates = useEmptyState();
  const Illustration = EmptyStates[iconKey];
  return (
    <EmptyWrapper>
      <Illustration />
      <EmptyTitle>{title}</EmptyTitle>
      {action}
    </EmptyWrapper>
  );
};

const EmptyWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  > svg {
    width: 96px;
    height: auto;
  }
`;
const EmptyTitle = styled.div`
  color: ${(p) => p.theme.colors.primaryText};
  font-size: 13.5px;
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
`;
